import React, { useState, useEffect, useRef } from "react";
import { trans, setComoAfterThirdSymbol } from "../../../helpers/index";
import ApiManager from "../../../apiManager/index";
import ReactNotification from "react-notifications-component";
import ErrorModal from "../../Fragments/ErrorModal";
import Loading from "../../Fragments/Loading";
import Modal from "../../Fragments/Modal";
import config from "../../../baseConfig/index";
import { localStorageGetItem } from "../../../storage/index";

function Tariffs(props) {
  const [tariffList, setTariffList] = useState("");
  const [tariffButtons, setTariffButtons] = useState("");
  const [tariffErrorPrice, setTariffErrorPrice] = useState("");
  const [tariffErrorModalShow, setTariffErrorModalShow] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showTariffChangeWarningModal, setShowTariffChangeWarningModal] =
    useState(false);
  const [warningText, setWarningText] = useState("");
  const [pendingTariffChange, setPendingTariffChange] = useState(null);
  const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(false);
  const [showErrorDialogModal, setShowErrorDialogModal] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState("");
  const isMountedRef = useRef(false);
  const notificationDOMRef = useRef();

  useEffect(() => {
    if (props.parentState.switchAccount) {
      setTariffList("");
      setTariffButtons("");
    }
  }, [props.parentState.switchAccount]);

  useEffect(() => {
    isMountedRef.current = true;

    initAsyncCalls();

    return () => {
      isMountedRef.current = false;
    };
  }, []);
  function initAsyncCalls() {
    ApiManager.getRequest(
      {
        jwt: props.getDecryptedToken(),
      },
      "/tariff/list"
    ).then(tariffListSuccess, errorCallBack);
  }

  function tariffListSuccess(resolve) {
    if (!isMountedRef.current) return;

    let tariffButtonsList = {};

    if (resolve.data.status === "OK") {
      resolve.data.data.others.forEach((item) => {
        if (item.url !== "") {
          tariffButtonsList[item.billing_id + "Disabled"] = false;
        }
      });
    }

    setTariffList(resolve.data);
    setTariffButtons(tariffButtonsList);
  }

  function errorCallBack() {
    setShowErrorModal(true);
  }

  function addNotification(inMessage, type = "success") {
    if (!isMountedRef.current) return;

    notificationDOMRef.current?.addNotification({
      title: "",
      message: inMessage,
      type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true },
    });
  }

  function sendTariffChangeRequest(billingId) {
    if (!billingId) return;

    const currentButtons = { ...tariffButtons };
    currentButtons[billingId + "Disabled"] = true;
    setTariffButtons(currentButtons);

    ApiManager.postRequest(
      {
        soc: billingId,
        jwt: props.getDecryptedToken(),
        _token: props.csrf_token.data,
      },
      "/tariff/change"
    ).then(
      (resolve) => {
        if (!isMountedRef.current) return;
        const updatedButtons = { ...currentButtons };
        updatedButtons[billingId + "Disabled"] = false;
        setTariffButtons(updatedButtons);
        setConfirmButtonDisabled(false);
        if (resolve.data.status === "OK") {
          setTariffList("");
          setTariffButtons("");
          initAsyncCalls();
          setShowTariffChangeWarningModal(false);
          setShowErrorDialogModal(false);
          addNotification(
            trans(props.trans, "tariff.change.sucess.title"),
            "success"
          );
        } else if (resolve.data.status === "ERROR_DIALOG") {
          setErrorDialogMessage(resolve.data.message || resolve.data.status);
          setShowErrorDialogModal(true);
        } else if (resolve.data.status === "ERROR_B2B_TARIFF_CHANGE") {
          setWarningText("");
          setShowTariffChangeWarningModal(true);
        } else {
          setShowTariffChangeWarningModal(false);
        }

        setPendingTariffChange(null);
      },
      (error) => {
        errorCallBack(error);
        addNotification(
          trans(props.trans, "detach_modal.error.message"),
          "danger"
        );
        setConfirmButtonDisabled(false);
        setShowTariffChangeWarningModal(false);
        setPendingTariffChange(null);
      }
    );
  }
  function tariffChange(billingId, itemPrice, itemCanChange, warningText) {
    if (!itemCanChange) {
      setTariffErrorPrice(itemPrice);
      setTariffErrorModalShow(true);
      return;
    }

    if (warningText) {
      setWarningText(warningText);
      setPendingTariffChange(billingId);
      setShowTariffChangeWarningModal(true);
      return;
    }

    sendTariffChangeRequest(billingId);
  }

  function topSection() {
    let result = <Loading withBox={true} />;

    if (tariffList !== "" && tariffList.status === "OK") {
      result = (
        <p className="empty-message">{trans(props.trans, "empty.message")}</p>
      );

      if (tariffList.data.current) {
        let list = "";

        if (tariffList.data.current.related_important_inclusions.length) {
          list = tariffList.data.current.related_important_inclusions.map(
            (item, index) => {
              return (
                <li className="list__item pr" key={index}>
                  <div className="list__link list__link--white-bg pr">
                    <h2 className="list__inner-title">{item.name}</h2>
                    <div className="list__inner-price">
                      <img
                        className="list__inner-img ver-top-box"
                        src={item.icon}
                        alt={item.name}
                      />
                      <div className="list__inner-info-title monserrat-medium fs20 ver-top-box">
                        {setComoAfterThirdSymbol(item.value) || item.value}{" "}
                        {item.measurement_unit}
                      </div>
                    </div>
                  </div>
                </li>
              );
            }
          );

          list = (
            <div className="main-wrapper__list-out">
              <ul className="list list--inline tc">{list}</ul>
            </div>
          );
        }

        result = (
          <>
            <a
              className="main-wrapper__sub-title main-wrapper__sub-title--package main-wrapper__sub-title--package-yellow db pr sprite-b clear-fix"
              href={tariffList.data.current.url.replace(/\?ref=mobile/, "")}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="main-wrapper__sub-title-inner-left db fl monserrat-medium">
                {trans(props.trans, "tariff.title")}
              </span>
              <span className="main-wrapper__sub-title-inner-right db fr">
                <span className="main-wrapper__sub-title-inner-tariff monserrat-medium">
                  {tariffList.data.current.name}
                </span>
                <span className="list__next-btn ver-top-box sprite"> </span>
              </span>
            </a>
            {list}
          </>
        );
      }
    }

    if (tariffList !== "" && tariffList.status === "ERROR") {
      result = <p className="error-message">{tariffList.message}</p>;
    }

    return (
      <section className="main-wrapper__services main-wrapper__services--with-space">
        {result}
      </section>
    );
  }

  function listSection() {
    let result = <Loading withBox={true} />;

    if (tariffList !== "" && tariffList.status === "OK") {
      result = "";

      if (tariffList.data.others.length) {
        const items = tariffList.data.others.map((item, index) => {
          let related = "";

          if (item.related_important_inclusions.length) {
            related = item.related_important_inclusions.map(
              (listItem, listIndex) => {
                return (
                  <li className="list__item" key={listIndex}>
                    <div className="list__link pr clear-fix">
                      <img
                        className="list__img fl db"
                        src={listItem.icon}
                        alt={listItem.name}
                      />
                      <div className="list__inner">
                        <div className="list__inner-info ver-top-box tl">
                          {listItem.name}
                        </div>
                        <div className="list__inner-info list__inner-info--dark fb ver-top-box tr">
                          {listItem.value}
                          {listItem?.value !== listItem?.measurement_unit
                            ? listItem.measurement_unit
                            : null}
                        </div>
                      </div>
                    </div>
                  </li>
                );
              }
            );
          }

          let title = (
            <a
              className="main-wrapper__sub-title main-wrapper__sub-title--link db monserrat-medium tl pr sprite-b trans-background"
              href={item.url.replace(/\?ref=mobile/, "")}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.name}
              <span className="list__next-btn db sprite"> </span>
            </a>
          );

          let button = (
            <button
              className={`btn btn--white${
                tariffButtons[item.billing_id + "Disabled"]
                  ? " btn--loading"
                  : ""
              }`}
              type="button"
              disabled={tariffButtons[item.billing_id + "Disabled"]}
              onClick={() =>
                tariffChange(
                  item.billing_id,
                  item.price,
                  item.can_change,
                  item.change_warning
                )
              }
            >
              {trans(props.trans, "tariff.change_button_title")}
            </button>
          );
          if (item.can_change == false && item.change_warning == "") {
            button = "";
          }
          let listClass = "";
          if (item.url === "") {
            title = (
              <h2 className="main-wrapper__sub-title main-wrapper__sub-title--normal monserrat-medium pr sprite-b">
                {item.name}
              </h2>
            );
            button = "";
            listClass = " mb-none";
          }

          return (
            <div
              className="main-wrapper__third-list-item ver-top-box"
              key={index}
            >
              <section className="main-wrapper__services">
                {title}
                <div className="main-wrapper__list-out main-wrapper__list-out--pb-space">
                  <ul
                    className={`list list--inclusions list--inner${listClass}`}
                  >
                    {related}
                  </ul>
                  {button}
                </div>
              </section>
            </div>
          );
        });

        result = (
          <div className="main-wrapper__third-list main-wrapper__third-list--tariffs">
            {items}
          </div>
        );
      }
    }

    if (tariffList !== "" && tariffList.status === "ERROR") {
      result = (
        <section className="main-wrapper__services main-wrapper__services--with-space">
          <p className="error-message">{tariffList.message}</p>
        </section>
      );
    }

    return result;
  }

  function notificationRender() {
    if (!isMountedRef.current) return null;

    return <ReactNotification ref={notificationDOMRef} />;
  }

  function errorModal() {
    if (!showErrorModal) return null;

    return (
      <ErrorModal
        title={trans(props.trans, "error.modal.title")}
        description={trans(props.trans, "error.modal.description")}
        action_text={trans(props.trans, "error.modal.action_text")}
      />
    );
  }

  function errorTariffChangeModal() {
    if (!tariffErrorModalShow) return null;

    return (
      <Modal
        title={trans(props.trans, "tariff.change_error.title")}
        htmlDescription={trans(props.trans, "tariff.change_error.desc").replace(
          /%s/,
          "<b>" + tariffErrorPrice + "</b>"
        )}
        agreeText={trans(props.trans, "tariff.change_error.agree")}
        agreeAction={() => {
          setTariffErrorPrice("");
          setTariffErrorModalShow(false);
        }}
        className="modal--full modal--bottom-none-space"
      />
    );
  }

  function errorDialogModal() {
    if (!showErrorDialogModal) return null;

    const currentLanguage =
      localStorageGetItem("defaultLngPrefix") || config.defaultLngPrefix;
    const baseUrl = config.translationUrl
      ? config.translationUrl.replace("/myaccount/", "/")
      : config.apiUrl.replace("/api/", "/");
    const officesUrl = `${baseUrl}${currentLanguage}/offices/`;

    return (
      <Modal
        title={trans(props.trans, "error.modal.title")}
        description={
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/img/img_no_connection.png`}
              alt="Error Dialog"
            />
            <span
              style={{
                display: "block",
                fontSize: "16px",
                marginBottom: "15px",
              }}
            >
              {trans(props.trans, "tariff.change_dialog.error.title")}
            </span>
            <a
              href={officesUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#007bff",
                textDecoration: "underline",
                fontSize: "14px",
              }}
            >
              {trans(props.trans, "offices.link.text") || "Visit our offices"}
            </a>
          </span>
        }
        agreeText={trans(props.trans, "tariff.change_error.agree")}
        agreeAction={() => {
          setShowErrorDialogModal(false);
          setErrorDialogMessage("");
        }}
        className="modal--full modal--bottom-none-space"
      />
    );
  }

  function errorTariffChangeWaringModal(warning_text) {
    if (!showTariffChangeWarningModal) return null;

    if (warning_text) {
      return (
        <div className="modal fade show scroller-block modal--full modal--bottom-none-space">
          <div className="modal__content modal-dialog pr">
            <div className="table">
              <div className="table-cell">
                <div className="modal__inner pr">
                  <h3 className="modal__title monserrat-medium fs30 tc">
                    {trans(props.trans, "tariff.change_error.title")}
                  </h3>

                  <p className="modal__description fs13 tc">{warning_text}</p>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "1rem",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      className={`btn btn--with-space btn--yellow${
                        confirmButtonDisabled ? " btn--loading" : ""
                      }`}
                      type="button"
                      disabled={confirmButtonDisabled}
                      onClick={() => {
                        setConfirmButtonDisabled(true);
                        sendTariffChangeRequest(pendingTariffChange);
                      }}
                    >
                      {trans(props.trans, "tariff.change_button_title")}
                    </button>
                    <button
                      className="btn btn--white"
                      type="button"
                      onClick={() => {
                        setShowTariffChangeWarningModal(false);
                        setWarningText("");
                        setPendingTariffChange(null);
                      }}
                    >
                      {trans(props.trans, "history.modal.cancel_title")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <Modal
        title={trans(props.trans, "tariff.change_error.title")}
        description={
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/img/img_TP_change.png`}
              alt="Tariff Change Warning"
            />
            <span style={{ display: "block" }}>
              {trans(props.trans, "tariff.change_warning_title")}
            </span>
            <b
              style={{ color: "#2c3843", fontSize: "20px", marginTop: "10px" }}
            >
              010 700700
            </b>
          </span>
        }
        agreeText={trans(props.trans, "tariff.change_error.agree")}
        agreeAction={() => {
          setShowTariffChangeWarningModal(false);
        }}
        className="modal--full modal--bottom-none-space"
      />
    );
  }
  if (props.parentState.switchAccount) {
    initAsyncCalls();
  }

  return (
    <>
      {notificationRender()}
      {topSection()}
      {listSection()}
      {errorTariffChangeModal()}
      {errorModal()}
      {errorDialogModal()}
      {errorTariffChangeWaringModal(warningText)}
    </>
  );
}

export default Tariffs;
